import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8000",
  withCredentials: false,
});

// Helper to deeply clean SSN and Phone fields
const deepCleanSSNPhone = (obj) => {
  if (Array.isArray(obj)) {
    obj.forEach(item => deepCleanSSNPhone(item));
  } else if (obj !== null && typeof obj === 'object') {
    Object.keys(obj).forEach(key => {
      if (['ssn_or_tin', 'phone', 'ssn', 'tin'].includes(key) && typeof obj[key] === 'string' && !obj[key].includes('*')) {
        obj[key] = obj[key].replace(/\D/g, '');
      } else {
        deepCleanSSNPhone(obj[key]);
      }
    });
  }
};

// Request interceptor to add auth token and clean payloads
axiosInstance.interceptors.request.use(
  (config) => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const accessToken = userData.access_token;
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    
    // Deep clean SSN and Phone fields if data exists
    if (config.data) {
      deepCleanSSNPhone(config.data);
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const refreshToken = userData.refresh_token;
      
      if (refreshToken) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL || "http://localhost:8000"}/auth/refresh`,
            { refresh_token: refreshToken }
          );
          
          const { access_token, refresh_token: new_refresh_token } = response.data;
          localStorage.setItem("userData", JSON.stringify({
            ...userData,
            access_token,
            refresh_token: new_refresh_token
          }));
          
          originalRequest.headers["Authorization"] = `Bearer ${access_token}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem("userData");
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;

